import { render, staticRenderFns } from "./accountAddState.vue?vue&type=template&id=0ba296c7&scoped=true&"
import script from "./accountAddState.vue?vue&type=script&lang=js&"
export * from "./accountAddState.vue?vue&type=script&lang=js&"
import style0 from "./accountAddState.vue?vue&type=style&index=0&id=0ba296c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba296c7",
  null
  
)

export default component.exports